import { AuthHelper } from '../../utils/auth_helper';
import { SellerLogoutForm } from "../../components/seller/SellerLogoutForm";

import React from "react";
import Grid from '@mui/material/Grid';


function SellerLogout() {

  return (
    <div>
      <AuthHelper/>
      <div className="tw-px-5 sm:tw-ml-20 tw-text-left">
        
          <Grid container direction="row" alignItems="center" justifyContent="" >

            <Grid container>
              <Grid item xs={12} sm={12}>
                <span className="tw-p-10 tw-text-3xl"><p>Seller Logout</p></span>
              </Grid>
            </Grid>

            <SellerLogoutForm />

          </Grid>
          
      </div>

    </div>
  );

}


export { SellerLogout };
